import { createAuthClient } from 'better-auth/react';

const baseURL = import.meta.env.VITE_API_URL
  ? `${import.meta.env.VITE_API_URL}/api/auth`
  : `${window.location.origin}/api/auth`;

export const authClient = createAuthClient({
  baseURL,
});

export const { signIn, signOut, signUp, useSession, updateUser } = authClient;

/**
 * iOS often fails the first request after the app resumes from the
 * background ("Load failed"), so retry a network error before giving up.
 */
export async function getSessionWithRetry(attempts = 3, delayMs = 500) {
  for (let attempt = 1; ; attempt++) {
    try {
      return await authClient.getSession();
    } catch (error) {
      if (attempt >= attempts) throw error;
      await new Promise((resolve) => setTimeout(resolve, delayMs * attempt));
    }
  }
}
